import React from 'react';
import { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import {
	authHeader,
	handleResponse,
	configureFakeBackend
} from '../services/fack.backend';
import configDB from '../data/customizer/config'
import PrivateRoute from './private-route';
import Signin from '../auth/signin';
import AppLayout from '../components/app';
import Login from '../pages/login';
import LoginWithBgImg from '../pages/loginWithBgImg';
import LoginWithVideo from '../pages/loginWithVideo';
import Signup from '../pages/signup';
import SignupWithImg from '../pages/signupWithImg';
import SignupWithVideo from '../pages/signupWithVideo';
import UnlockUser from '../pages/unlockUser';
import ForgetPwd from '../pages/forgetPwd';
import ResetPwd from '../pages/resetPwd';
import ComingSoon from '../pages/comingsoon';
import ComingSoonImg from '../pages/comingsoonImg';
import ComingSoonVideo from '../pages/comingsoonVideo';
import Maintenance from '../pages/maintenance';
import Error400 from '../pages/errors/error400';
import Error401 from '../pages/errors/error401';
import Error403 from '../pages/errors/error403';
import Error404 from '../pages/errors/error404';
import Error500 from '../pages/errors/error500';
import Error503 from '../pages/errors/error503';
import { layoutRoutes } from './layouts-routes';
import { mastersRoutes } from './masters-routes';
import { opdReportRoutes, opdTransactionRoutes } from './opd-routes';
import { ipdMasterRoutes, ipdReportRoutes, ipdTransactionRoutes } from './ipd-routes';
import { useSelector } from 'react-redux';
import { diagnosisMasterRoutes, diagnosisTransactionRoutes } from './diagnosis-routes';
import { medicalStoreMasterRoutes, medicalStoreTransactionRoutes } from './medical-store-routes';
import { utilityRoutes } from './utility-routes';
import Callback from '../auth/callback';
import { useDispatch } from 'react-redux';
import { refreshUserPermissions } from '../api/authAPI';
import { REFRESH_USER_PERMISSIONS } from '../redux/actionTypes';
import PermissionRoute from '../components/permissionGuardComponent/PermissionRoute';
import { messageRoutes } from './message-routes';
import Default from '../components/dashboard/defaultCompo/default';
import CompanySelection from '../auth/companySelection';

import LandingPage from '../pages/landingpage';
import BookingModule from '../pages/landingsections/BookingModule';
import PrivacyPolicy from '../pages/landingsections/PrivacyPolicy';
import TermsCondition from '../pages/landingsections/TermsCondition';
import FinancialYearSelection from '../auth/financialYearSelection';


configureFakeBackend();

const MainRoutes = () => {
	const dispatch = useDispatch();
	// Get the current authentication status from Redux
	const isAuthenticated = useSelector(
		state => state?.authReducer?.isAuthenticated || false
	);

	const company = useSelector(
		state => state?.authReducer?.company || null
	);

	useEffect(
		() => {
			const initializeUser = async () => {
				const token = localStorage.getItem("token");
				// ONLY run if Redux says we are authenticated AND we have a token
				if (isAuthenticated && token && company && company?._id) {
					try {
						const response = await refreshUserPermissions();
						if (response.success) {
							dispatch({
								type: REFRESH_USER_PERMISSIONS,
								payload: response.data.permissions
							});
						} else {
							console.error("error", response.message);
						}
					} catch (error) {
						console.error("Session sync failed:", error.message);
						// If the token is invalid, force logout to clear the bad state
						dispatch({ type: "LOGOUT" });
					}
				}
			};

			initializeUser();
		},
		[isAuthenticated, company]
	);

	useEffect(() => {
		// const abortController = new AbortController();
		// const requestOptions = { method: 'GET', headers: authHeader() };
		// fetch('/users', requestOptions).then(handleResponse)
		const color = localStorage.getItem('color')
		const layout = localStorage.getItem('layout_version') || configDB.data.color.layout_version
		document.body.classList.add(layout);
		console.ignoredYellowBox = ['Warning: Each', 'Warning: Failed'];
		console.disableYellowBox = true;
		document.getElementById("color").setAttribute("href", `/assets/css/${color}.css`);

		// return function cleanup() {
		//   abortController.abort();
		// }
	}, []);

	const protectedRoutes = [
		...mastersRoutes,
		...opdTransactionRoutes,
		...opdReportRoutes,
		...ipdMasterRoutes,
		...ipdTransactionRoutes,
		...ipdReportRoutes,
		...diagnosisMasterRoutes,
		...diagnosisTransactionRoutes,
		...medicalStoreMasterRoutes,
		...medicalStoreTransactionRoutes,
		...utilityRoutes,
		...messageRoutes
	];

	return (
		<>
			<Routes>
				<Route element={<PrivateRoute />} >
					<Route element={<AppLayout />} >
						{/* DEFAULT DASHBOARD */}

						{layoutRoutes.map(({ path, Component }, i) => (
							<Route
								key={i}
								path={path}
								element={Component}
							/>
						))}
						{protectedRoutes.map(({ path, Component, permission }, i) => (
							<Route
								key={i}
								path={path}
								element={
									<PermissionRoute
										permission={permission}
										element={Component}
									/>
								}
							/>
						))}
					</Route>
				</Route>
				<Route exact path={`/login`} element={<Signin />} />
				<Route path={`/company-selection`} element={<CompanySelection />} />
				<Route path={`/financial-year-selection`} element={<FinancialYearSelection />} />
				<Route path={`/pages/login`} element={<Login />} />
				<Route path={`/pages/loginWithBgImg`} element={<LoginWithBgImg />} />
				<Route path={`/pages/loginWithVideo`} element={<LoginWithVideo />} />
				<Route path={`/pages/signup`} element={<Signup />} />
				<Route path={`/pages/signupWithImg`} element={<SignupWithImg />} />
				<Route path={`/pages/signupWithVideo`} element={<SignupWithVideo />} />
				<Route path={`/pages/unlockUser`} element={<UnlockUser />} />
				<Route path={`/pages/forgetPwd`} element={<ForgetPwd />} />
				<Route path={`/pages/resetPwd`} element={<ResetPwd />} />
				<Route path={`/pages/comingsoon`} element={<ComingSoon />} />
				<Route path={`/pages/comingsoonImg`} element={<ComingSoonImg />} />
				<Route path={`/pages/comingsoonVideo`} element={<ComingSoonVideo />} />
				<Route path={`/pages/maintenance`} element={<Maintenance />} />
				<Route path={`/pages/errors/error400`} element={<Error400 />} />
				<Route path={`/pages/errors/error401`} element={<Error401 />} />
				<Route path={`/pages/errors/error403`} element={<Error403 />} />
				<Route path={`/pages/errors/error404`} element={<Error404 />} />
				<Route path={`/pages/errors/error500`} element={<Error500 />} />
				<Route path={`/pages/errors/error503`} element={<Error503 />} />
				<Route path="/callback" element={<Callback />} />
				<Route path="*" element={<Error404 />} />

				{/*  landingpage  */}
				<Route path="/" element={<LandingPage />} />
				<Route path="/book-demo" element={<BookingModule />} />
				<Route path="/privacy-policy" element={<PrivacyPolicy />} />
				<Route path="/terms-conditions" element={<TermsCondition />} />


			</Routes>
		</>
	);


};

export default MainRoutes;